import { render, staticRenderFns } from "./EventPopup.vue?vue&type=template&id=b494e8ae&scoped=true"
import script from "./EventPopup.vue?vue&type=script&lang=js"
export * from "./EventPopup.vue?vue&type=script&lang=js"
import style0 from "./EventPopup.vue?vue&type=style&index=0&id=b494e8ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b494e8ae",
  null
  
)

export default component.exports